import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTipoFichaSubList, modifyTipoFichaSub, removeTipoFichaSub, addTipoFichaSub, updateTipoFichaSubListDB } from '../../actions/tipo_ficha_sub_actions';
import { getTipoFichaList } from '../../actions/tipo_ficha_actions'

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoFichaSub extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTipoFichaList();
        this.props.getTipoFichaSubList();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkTipoFichaSub = (tipoFichaSub) => {

        if (this.props.tipoFichaSubList.find(tfs => (tfs.descr === tipoFichaSub.descr) && (tfs.id !== tipoFichaSub.id) && (tfs.iTipoficha === tipoFichaSub.iTipoficha) )) {
            this.messageDialog(`Ya existe un subtipo con descripción ${tipoFichaSub.descr}`);
            return false;
        } else if (!tipoFichaSub.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (parseInt(tipoFichaSub.factor) <= 0) {
            this.messageDialog('El factor debe ser mayor que cero');
            return false;
        }

        else return true;
    };

    editTipoFichaSub = (tipoFichaSub) => {

        this.props.openDialog('EditTipoFichaSub', {
            tipoFichaSub: tipoFichaSub,
            checkTipoFichaSub: this.checkTipoFichaSub,
            okHandler: (sf) => {
                this.props.setSaveState(true);
                this.props.modifyTipoFichaSub(sf);
            },
            tipoFichaList: this.props.tipoFichaList

        }, uuidv4());
    };

    newTipoFichaSub = () => {
        this.props.openDialog('EditTipoFichaSub', {
            tipoFichaSub: {},
            checkTipoFichaSub: this.checkTipoFichaSub,
            okHandler: (tp) => {
                this.props.setSaveState(true);
                this.props.addTipoFichaSub(tp);
            },
            tipoFichaList: this.props.tipoFichaList
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.props.tipoFichaSubList[i], { $merge: updated });
            if (this.checkTipoFichaSub(updatedRow)) {
                this.props.setSaveState(true);
                this.props.modifyTipoFichaSub(updatedRow);
            }
        }

    };

    handleDeleteRow = (tipoFichaSub) => {
        this.props.setSaveState(true);
        this.props.removeTipoFichaSub(tipoFichaSub);
    };

    render() {

        const { classes } = this.props;



        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>
                    <NeuriteGrid
                        id="m_r_t_f_s"
                        columns={[
                            { key: 'tipoFichaDescr', name: 'Tipo Ficha', editable: false, dragable: false, width: 200 },
                            { key: 'descr', name: 'Sub Tipo Ficha', editable: false, dragable: false, width: 200 },
                            { key: 'factor', name: 'Factor', tooltip: 'Número de puntos asociados a esta ficha', type: 'int', editable: false, dragable: false, width: 60 }
                        ]}
                        rows={this.props.tipoFichaSubList}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoFichaSub}
                        onEditClick={this.editTipoFichaSub}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tipoFichaSubList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTipoFichaSubListDB(this.props.tipoFichaSubList)
                }
                }>Guardar</Button>
            </div>
        );

    };

};

MaeAuxiliaresTipoFichaSub.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tipoFichaSubList: PropTypes.array.isRequired,
    tipoFichaList: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTipoFichaList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoFichaSub: PropTypes.func.isRequired,
    removeTipoFichaSub: PropTypes.func.isRequired,
    addTipoFichaSub: PropTypes.func.isRequired,
    updateTipoFichaSubListDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        tipoFichaSubList: state.tipoFichaSub.tipoFichaSubList,
        tipoFichaList: state.tipoFicha.tipoFichaList,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTipoFichaSubList,
        getTipoFichaList,
        openDialog,
        hideDialog,
        modifyTipoFichaSub,
        removeTipoFichaSub,
        addTipoFichaSub,
        updateTipoFichaSubListDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoFichaSub));

